import { createFileRoute, Link } from "@tanstack/react-router";
import { motion } from "motion/react";
import { useState } from "react";
import { Icon, Logo } from "@/components/ui";
import { passwortLinkAnfordern } from "../auth";

/**
 * „Passwort vergessen" (T072) — offen wie die Anmeldeseite, denn wer hier
 * landet, kommt gerade nicht hinein. Die Antwort ist IMMER dieselbe, ob es
 * die Adresse gibt oder nicht: Das Formular darf keine Kundenliste sein.
 */
export const Route = createFileRoute("/passwort-vergessen")({
	component: PasswortVergessenSeite,
});

function PasswortVergessenSeite() {
	const [email, setEmail] = useState("");
	const [laeuft, setLaeuft] = useState(false);
	const [fehler, setFehler] = useState<string | null>(null);
	const [gesendet, setGesendet] = useState(false);

	const absenden = async () => {
		setLaeuft(true);
		setFehler(null);
		try {
			const ergebnis = await passwortLinkAnfordern({ email: email.trim() });
			if (!ergebnis.ok) {
				setFehler(ergebnis.message);
				return;
			}
			setGesendet(true);
		} finally {
			setLaeuft(false);
		}
	};

	return (
		<div className="min-h-dvh grid place-items-center bg-bg p-6">
			<motion.div
				initial={{ opacity: 0, y: 14 }}
				animate={{ opacity: 1, y: 0 }}
				className="w-full max-w-sm"
			>
				<div className="mb-8">
					<Logo />
				</div>
				{gesendet ? (
					<>
						<h1 className="font-display text-display font-medium text-ink tracking-tight">
							Schau in dein Postfach
						</h1>
						<p className="text-ink-soft mt-2 leading-relaxed">
							Wenn es zu <span className="font-medium text-ink">{email.trim()}</span> ein Konto
							gibt, ist der Link zum neuen Passwort unterwegs — er ist 24 Stunden gültig. Auch den
							Spam-Ordner prüfen.
						</p>
						<Link to="/login" className="btn-secondary w-full mt-7 h-11">
							<Icon name="arrowLeft" size={16} /> Zur Anmeldung
						</Link>
					</>
				) : (
					<>
						<h1 className="font-display text-display font-medium text-ink tracking-tight">
							Passwort vergessen?
						</h1>
						<p className="text-ink-soft mt-1.5">
							Wir schicken dir einen Link, mit dem du ein neues setzt.
						</p>
						<form
							className="mt-7"
							onSubmit={(event) => {
								event.preventDefault();
								void absenden();
							}}
						>
							<label htmlFor="email" className="block">
								<span className="text-sm font-medium text-ink-soft">E-Mail-Adresse</span>
								<input
									id="email"
									type="email"
									required
									autoComplete="username"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									className="input"
								/>
							</label>
							{fehler !== null && (
								<p
									role="alert"
									className="mt-4 rounded-xl border border-negative/40 bg-negative/10 px-3 py-2 text-sm text-ink"
								>
									{fehler}
								</p>
							)}
							<button
								type="submit"
								disabled={laeuft}
								className="btn-primary w-full mt-6 h-12 text-body"
							>
								{laeuft ? "Einen Moment…" : "Link schicken"}
								<Icon name="send" size={17} />
							</button>
						</form>
						<p className="text-center text-caption text-ink-mute mt-5">
							<Link to="/login" className="hover:underline">
								Zurück zur Anmeldung
							</Link>
						</p>
					</>
				)}
			</motion.div>
		</div>
	);
}
